module.exports = __webpack_public_path__ + "static/media/profile_img.e843a1f0.png";